module.exports = __webpack_public_path__ + "static/media/md-trophy.2e69cc06.svg";